export const AGENDA_UNREAD_MESSAGES_SNACKBAR_CHAT_CLICKED_ANALYTICS =
  'agentsPwa/Agenda/UnreadMessageSnackbar/AGENDA_UNREAD_MESSAGES_SNACKBAR_CHAT_CLICKED_ANALYTICS';
